import moment from 'moment';
import React, { useState } from 'react';
import { LightgalleryItem } from 'react-lightgallery';
import { useSelector } from 'react-redux';

import magnify from '../../assets/img/icons/magnifying-glass-plus.svg';
import noImg from '../../assets/img/no-image.png';
import noScreenshot from '../../assets/img/screenshot_2.svg';
import { Image, ImageContainer, MagnifyIcon } from './selfieStyles';

const PhotoItem = props => {
  const { item, image, selfieImageId } = props;
  const [hover, setHover] = useState(false);
  const [imageId, setImageId] = useState(-1);

  const handleMouseEnter = () => {
    setHover(true);
    setImageId(selfieImageId);
  };

  const handleMouseLeave = () => {
    setHover(false);
    setImageId(-1);
  };

  return (
    <LightgalleryItem
      src={image || noImg}
      // key={k}
      group="group"
      subHtml={`<div class="col-xs-12 col-md-4 screenshot-desc-col">
          <div class="row">
            <p class="screenshot-desc-title">Employee Name: </p>
            <p class="screenshot-desc-text">
            ${item?.employee || 'Unknown'}
            </p>
          </div>
          <div class="row screenshot-desc-row-mobile">
            <p class="screenshot-desc-title">Office Number: </p>
            <p class="screenshot-desc-text">
            ${item?.office}</p>
          </div>
        </div>
          <div class="col-md-4 col-xs-12  screenshot-desc-col">
          <div class="row" style="justify-content: center;">
            <p class="screenshot-desc-title"></p>
            <p class="screenshot-desc-text"></p>
          </div>
          
        </div>
        <div class="col-md-4 col-xs-12 screenshot-desc-col">
          <div class="row" style="justify-content: flex-end">
            <p class="screenshot-desc-title">Time Stamp: </p>
            <p class="screenshot-desc-text">
            ${moment(item.created_at)
              .local()
              .clone()
              .startOf('hour')
              .format('h:mm A')} -${' '}
            ${moment(item.created_at)
              .local()
              .add(1, 'hour')
              .startOf('hour')
              .format('h:mm A')}
              </p>
          </div>
          <div class="row screenshot-desc-row-mobile" style="justify-content: flex-end;">
            <p class="screenshot-desc-title">Image Uploaded At: </p>
            <p class="screenshot-desc-text">
            ${moment(item.created_at).local().format('h:mm A, Do MMM, YYYY')}
              </p>
          </div>
        </div>`}
    >
      <ImageContainer
        isHovered={hover}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <Image src={image || noScreenshot} isHovered={hover} />
        {image && hover && imageId == selfieImageId && (
          <MagnifyIcon>
            <img src={magnify} height="25px" width="25px" />
          </MagnifyIcon>
        )}
      </ImageContainer>
    </LightgalleryItem>
  );
};

export default PhotoItem;
